import React from 'react'
import { Checkbox as AntCheckbox, Form, Popconfirm, Typography } from 'antd'
import PropTypes from 'prop-types'

import { antFormItemNamePropType } from '../../../common/prop-types'

const Checkbox = ({ name, value, label, onChange, disabled }) =>
  value === true ? (
    <Popconfirm
      disabled={disabled}
      placement="bottom"
      title={
        <Typography.Text>
          If you deactivate this diet then all alternatives on ingredients would
          be deleted <br /> Are you sure?
        </Typography.Text>
      }
      onConfirm={() => onChange(false)}
      okText="Yes"
      cancelText="No"
    >
      <AntCheckbox disabled={disabled} name={name} checked={value}>
        {label}
      </AntCheckbox>
    </Popconfirm>
  ) : (
    <AntCheckbox
      disabled={disabled}
      checked={value}
      onChange={() => onChange(true)}
    >
      {label}
    </AntCheckbox>
  )

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
}

Checkbox.defaultProps = {
  value: false,
  label: '',
  onChange: undefined,
  disabled: false,
}

const DietAvailableForCategorizationCheckbox = ({
  name,
  label,
  rules,
  disabled,
}) => (
  <Form.Item name={name} rules={rules}>
    <Checkbox disabled={disabled} name={name} label={label} />
  </Form.Item>
)

DietAvailableForCategorizationCheckbox.propTypes = {
  name: antFormItemNamePropType.isRequired,
  label: PropTypes.string,
  rules: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  ),
  disabled: PropTypes.bool,
}

DietAvailableForCategorizationCheckbox.defaultProps = {
  label: '',
  rules: undefined,
  disabled: false,
}

export default DietAvailableForCategorizationCheckbox
